import { Box } from '@mui/material';
import { Fragment } from 'react';
import { parseAccentRuns } from '../accent';
import { useSurface } from '../layouts/block-surface-context';
import { useLayoutStyles } from '../layouts/layout-context';
import type { Surface } from '../layouts/types';

/**
 * Renders `*accent*` runs as their own elements. Never markup: the asterisks exist so we need none.
 * `surface` is the one the block is written for; a block background can override it.
 */
export const AccentText = ({ text, surface }: { text: string; surface: Surface }) => {
  const s = useLayoutStyles('shared');
  const accent = s.accent[useSurface(surface)];

  return (
    <>
      {parseAccentRuns(text).map((run) =>
        run.accent ? (
          <Box component="em" key={run.start} sx={accent}>
            {run.text}
          </Box>
        ) : (
          <Fragment key={run.start}>{run.text}</Fragment>
        ),
      )}
    </>
  );
};
